import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Pill, ShoppingCart, ChevronRight } from 'lucide-react';

const DistributorSupplementsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in" data-testid="dist-supplements-page">
      <div className="pt-1">
        <h1 className="text-4xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Suplementos
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Gestiona ordenes de suplementos para tus clientes</p>
      </div>

      <button
        onClick={() => navigate('/distributor/supplements/create-order')}
        className="w-full bg-white rounded-2xl border border-gray-100/50 p-4 text-left shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group"
        data-testid="create-order-card"
      >
        <div className="flex items-center gap-4">
          <div
            className="rounded-2xl bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center shadow-lg flex-shrink-0 group-hover:scale-105 transition-transform duration-300"
            style={{ width: '52px', height: '52px', boxShadow: '0 4px 14px #F5990030' }}
          >
            <ShoppingCart size={24} className="text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-bold text-gray-900 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              Crear Orden de Suplementos
            </p>
            <p className="text-xs text-gray-400 mt-0.5">Selecciona suplementos y asignalos a un cliente</p>
          </div>
          <div className="text-gray-300 group-hover:text-gray-500 transition-colors">
            <ChevronRight size={16} />
          </div>
        </div>
      </button>

      <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-5 border border-orange-100/50" data-testid="supplements-info">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm">
            <Pill size={18} className="text-orange-500" />
          </div>
          <div>
            <p className="font-bold text-gray-800 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Como funciona</p>
            <p className="text-xs text-gray-500 mt-1 leading-relaxed">
              Crea una orden seleccionando los suplementos disponibles, define las cantidades y elige el cliente al que deseas asignarlos.
              Los suplementos apareceran en la seccion "Recomendados" del cliente.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorSupplementsPage;
